import React, { useEffect, useRef, useState } from 'react';
import { isMobileDevice } from '../utils/deviceUtils';

const getRandomBrightColor = () => {
    const colors = [
        '#FF2D8A', // Pink
        '#0000FF', // Blue
        '#FFB300', // Orange
        '#00FF00', // Green
        '#FF00FF', // Magenta
        '#00FFFF', // Cyan
    ];
    return colors[Math.floor(Math.random() * colors.length)];
};

const Cursor = () => {
    const cursorRef = useRef(null);
    const followerRef = useRef(null);
    const posX = useRef(0);
    const posY = useRef(0);
    const mouseX = useRef(0);
    const mouseY = useRef(0);
    const [cursorColor, setCursorColor] = useState(getRandomBrightColor());
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setIsMobile(isMobileDevice());
        
        // Only add cursor styles if not on mobile
        if (!isMobile) {
            document.body.style.cursor = 'none';
        } else {
            document.body.style.cursor = 'auto';
        }

        const interval = setInterval(() => {
            setCursorColor(getRandomBrightColor());
        }, 4500);

        return () => {
            clearInterval(interval);
            document.body.style.cursor = 'auto';
        };
    }, [isMobile]);

    useEffect(() => {
        if (isMobile) return;

        const cursor = cursorRef.current;
        const follower = followerRef.current;

        const handleMouseMove = (e) => {
            mouseX.current = e.clientX;
            mouseY.current = e.clientY;

            const target = e.target;
            const interactiveElements = ['A', 'BUTTON', 'INPUT', 'TEXTAREA'];
            if (
                interactiveElements.includes(target.tagName) ||
                target.closest('.project-card') ||
                target.closest('.service-large-card')
            ) {
                cursor.classList.add('hover');
                follower.classList.add('hover');
            } else {
                cursor.classList.remove('hover');
                follower.classList.remove('hover');
            }
        };

        const loop = () => {
            const deltaX = mouseX.current - posX.current;
            const deltaY = mouseY.current - posY.current;

            posX.current += deltaX * 0.21;
            posY.current += deltaY * 0.21;

            cursor.style.transform = `translate(${mouseX.current}px, ${mouseY.current}px) scale(${deltaX ? 1.2 : 1})`;
            follower.style.transform = `translate(${posX.current - 4}px, ${posY.current - 4}px) scale(${deltaX ? 0.8 : 1})`;

            requestAnimationFrame(loop);
        };

        document.addEventListener('mousemove', handleMouseMove);
        loop();

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
        };
    }, [isMobile]);

    if (isMobile) return null;

    return (
        <>
            <div ref={cursorRef} className="cursor" style={{ borderColor: cursorColor, background: cursorColor }}></div>
            <div ref={followerRef} className="cursor-follower" style={{ background: cursorColor }}></div>
        </>
    );
};

export default Cursor;